import { type CopilotThemeRefreshRate } from 'owa-copilot-themes-types';
import { owaDate, addHours, addDays, addWeeks, addMonths } from 'owa-datetime';
import { getStore } from '../store/store';

export default function getCopilotThemeRequiresUpdate(): boolean {
    const refreshRate = getStore().options.refreshRate as CopilotThemeRefreshRate;

    // If the theme is not selected or the refresh rate is set to 'None', we don't need to update the theme
    if (!getStore().options.isSelected || refreshRate === 'None') {
        return false;
    }

    const lastRefreshDate = Date.parse(getStore().options.lastRefreshDate);
    const currentDate = owaDate();

    switch (refreshRate) {
        case 'FourHours':
            return (
                currentDate >= addHours(owaDate('UTC', new Date(lastRefreshDate).toISOString()), 4)
            );
        case 'Daily':
            return (
                currentDate >= addDays(owaDate('UTC', new Date(lastRefreshDate).toISOString()), 1)
            );
        case 'Weekly':
            return (
                currentDate >= addWeeks(owaDate('UTC', new Date(lastRefreshDate).toISOString()), 1)
            );
        case 'Monthly':
            return (
                currentDate >= addMonths(owaDate('UTC', new Date(lastRefreshDate).toISOString()), 1)
            );
        default:
            return false;
    }
}
